// extracted by mini-css-extract-plugin
export default {"root":"MessageBox__root--SgqNRd"};